<app-modal-base [title]="dialogTitle" [hasSubmit]="false" cancelType="CLOSE">
  <ng-container main *ngTemplateOutlet="content"></ng-container>
</app-modal-base>

<ng-template #content>
  <div mat-dialog-content>
    <div class="tabs-container">
      <div class="tabs-list">
        <button mat-flat-button [class]="buttonMonthlyCss" (click)="changePlanToMonthly()">Mensuel</button>
        <button mat-flat-button [class]="buttonYearlyCss" (click)="changePlanToYearly()">Annuel</button>
      </div>
    </div>
    <div class="logo"><img src="assets/images/logo_eemo_ee_white.svg" /></div>
    <div class="pricing-container">
      <div class="pricing-grid">
        <div class="label">
          <div><span class="title">Agent Premium - {{ textTitle }}</span></div>
          <div><span class="desc">Accés illimité à EEMO pendant {{ textDuration }}, sans Engagement.</span></div>
        </div>
        <div class="price">
          <span class="amount">{{ price }}&nbsp;€</span>
          <span class="freq">par <br>{{ priceText }}</span>
        </div>
        <div class="subscribe">
          <button mat-flat-button color="accent" (click)="subscribeUser()">
            <ng-container *ngIf="loading; else text">
              <mat-icon>
                <mat-spinner diameter="20">
                </mat-spinner>
              </mat-icon>
            </ng-container>
          </button>
          <ng-template #text>M'abonner</ng-template>
        </div>
        <div class="features">
          <div class="title">Fonctionnalités&nbsp;:</div>
          <div class="feature-list">
            <div class="feature">
              <div class="icon"><svg focusable="false" fill="#ffffff" color="#ffffff" fill-opacity="0.7" height="16"
                  viewBox="0 0 16 16" width="16">
                  <path
                    d="m8 16c-4.418278 0-8-3.581722-8-8s3.581722-8 8-8 8 3.581722 8 8-3.581722 8-8 8zm3.0832728-11.00479172-4.0832728 4.09057816-1.79289322-1.79289322c-.39052429-.39052429-1.02368927-.39052429-1.41421356 0s-.39052429 1.02368927 0 1.41421356l2.5 2.50000002c.39052429.3905243 1.02368927.3905243 1.41421356 0l4.79037962-4.79768495c.3905243-.3905243.3905243-1.02368927 0-1.41421357-.3905243-.39052429-1.0236893-.39052429-1.4142136 0z"
                    fill-rule="evenodd"></path>
                </svg>
              </div>
              <span class="feature-text">Nombre de biens illimités</span>
            </div>
            <div class="feature">
              <div class="icon"><svg focusable="false" fill="#ffffff" color="#ffffff" fill-opacity="0.7" height="16"
                  viewBox="0 0 16 16" width="16">
                  <path
                    d="m8 16c-4.418278 0-8-3.581722-8-8s3.581722-8 8-8 8 3.581722 8 8-3.581722 8-8 8zm3.0832728-11.00479172-4.0832728 4.09057816-1.79289322-1.79289322c-.39052429-.39052429-1.02368927-.39052429-1.41421356 0s-.39052429 1.02368927 0 1.41421356l2.5 2.50000002c.39052429.3905243 1.02368927.3905243 1.41421356 0l4.79037962-4.79768495c.3905243-.3905243.3905243-1.02368927 0-1.41421357-.3905243-.39052429-1.0236893-.39052429-1.4142136 0z"
                    fill-rule="evenodd"></path>
                </svg>
              </div>
              <span class="feature-text">Partages illimités</span>
            </div>
            <div class="feature">
              <div class="icon"><svg focusable="false" fill="#ffffff" color="#ffffff" fill-opacity="0.7" height="16"
                  viewBox="0 0 16 16" width="16">
                  <path
                    d="m8 16c-4.418278 0-8-3.581722-8-8s3.581722-8 8-8 8 3.581722 8 8-3.581722 8-8 8zm3.0832728-11.00479172-4.0832728 4.09057816-1.79289322-1.79289322c-.39052429-.39052429-1.02368927-.39052429-1.41421356 0s-.39052429 1.02368927 0 1.41421356l2.5 2.50000002c.39052429.3905243 1.02368927.3905243 1.41421356 0l4.79037962-4.79768495c.3905243-.3905243.3905243-1.02368927 0-1.41421357-.3905243-.39052429-1.0236893-.39052429-1.4142136 0z"
                    fill-rule="evenodd"></path>
                </svg>
              </div>
              <span class="feature-text">Liaison données data.gouv</span>
            </div>
            <div class="feature">
              <div class="icon"><svg focusable="false" fill="#ffffff" color="#ffffff" fill-opacity="0.7" height="16"
                  viewBox="0 0 16 16" width="16">
                  <path
                    d="m8 16c-4.418278 0-8-3.581722-8-8s3.581722-8 8-8 8 3.581722 8 8-3.581722 8-8 8zm3.0832728-11.00479172-4.0832728 4.09057816-1.79289322-1.79289322c-.39052429-.39052429-1.02368927-.39052429-1.41421356 0s-.39052429 1.02368927 0 1.41421356l2.5 2.50000002c.39052429.3905243 1.02368927.3905243 1.41421356 0l4.79037962-4.79768495c.3905243-.3905243.3905243-1.02368927 0-1.41421357-.3905243-.39052429-1.0236893-.39052429-1.4142136 0z"
                    fill-rule="evenodd"></path>
                </svg>
              </div>
              <span class="feature-text">Tarifs Carte EEMO priviligiés</span>
            </div>
            <div *ngIf="isPlanYearly; else noSaving" class="feature saving">
              <div class="icon"><svg focusable="false" fill="#70b62c" color="#ffffff" fill-opacity="0.7" height="16"
                  viewBox="0 0 16 16" width="16">
                  <path
                    d="m8 16c-4.418278 0-8-3.581722-8-8s3.581722-8 8-8 8 3.581722 8 8-3.581722 8-8 8zm3.0832728-11.00479172-4.0832728 4.09057816-1.79289322-1.79289322c-.39052429-.39052429-1.02368927-.39052429-1.41421356 0s-.39052429 1.02368927 0 1.41421356l2.5 2.50000002c.39052429.3905243 1.02368927.3905243 1.41421356 0l4.79037962-4.79768495c.3905243-.3905243.3905243-1.02368927 0-1.41421357-.3905243-.39052429-1.0236893-.39052429-1.4142136 0z"
                    fill-rule="evenodd"></path>
                </svg>
              </div>
              <span class="feature-text">20% d'économie</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #noSaving>
  <div class="no-saving">&nbsp;</div>
</ng-template>